import { render } from "./SuggestionsComp.vue?vue&type=template&id=2423b90c&scoped=true"
import script from "./SuggestionsComp.vue?vue&type=script&lang=js"
export * from "./SuggestionsComp.vue?vue&type=script&lang=js"

import "./SuggestionsComp.vue?vue&type=style&index=0&id=2423b90c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2423b90c"]])

export default __exports__